import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.isVisible,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isVisible) = $event)),
    "close-on-press-escape": "",
    "append-to-body": "",
    width: "30%",
    center: "",
    "body-class": "multi-whitelabel-dialog__body",
    "footer-class": "multi-whitelabel-dialog__footer",
    "header-class": "multi-whitelabel-dialog__header",
    onClose: _ctx.closeDialog
  }, {
    header: _withCtx(() => [...(_cache[2] || (_cache[2] = [
      _createElementVNode("h4", null, " Additional whitelabel(-s) ", -1 /* CACHED */)
    ]))]),
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        class: "multi-whitelabel-dialog__footer-button",
        type: "primary",
        onClick: _ctx.addWhitelabel
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
          _createTextVNode(" Add ", -1 /* CACHED */)
        ]))]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_select, {
        modelValue: _ctx.selectedWhitelabelList,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedWhitelabelList) = $event)),
        placeholder: "Select whitelabel(-s)",
        loading: _ctx.isWhitelabelListLoading,
        multiple: "",
        clearable: "",
        filterable: "",
        "reserve-keyword": false,
        teleported: false,
        "value-key": "id",
        "popper-class": "multi-whitelabel-dialog__select-dropdown"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableWhitelabelList, ({id, name, slug}) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: id,
              label: name,
              value: { slug, id }
            }, null, 8 /* PROPS */, ["label", "value"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["modelValue", "loading"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue", "onClose"]))
}